import script from "./KnowledgeBaseView.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeBaseView.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeBaseView.vue?vue&type=style&index=0&id=1d2fd0e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2fd0e5"]])

export default __exports__